import { TOKEN } from "../../Config";

export const Authen = () => {
  // const user =  { loggedIn: false };
  const token = localStorage.getItem(TOKEN);
  return token != null;
};
